const subscriptionNL = {
    "view": {
        "table": {
            "title": "Uw Abonnement",
            "column": {
                "subscriptionTier": "Abonnementsniveau",
                "startDate": "Startdatum",
                "currentPeriodStart": "Huidige Periode Start",
                "currentPeriodEnd": "Huidige Periode Einde",
                "autoRenewal": "Automatische Verlenging",
                "status": "Status",
                "action": "Actie"
            },
            "label": {
                "status_active": "Actief",
                "status_incomplete": "Onvolledig",
                "status_incomplete_expired": "Onvolledig Verlopen",
                "status_unpaid": "Onbetaald",
                "status_past_due": "Achterstallig",
                "status_cancelled": "Geannuleerd",
                "status_expired": "Verlopen"
            },
            "actionDropdown": {
                "label": {
                    "action": "Actie"
                },
                "button": {
                    "enableAutoRenewal": "Automatische Verlenging Inschakelen",
                    "upgradeSubscription": "Abonnement Upgraden",
                    "cancelSubscription": "Abonnement Annuleren",
                    "resumeSubscription": "Abonnement Hervatten",
                    "retryPayment": "Betaling Opnieuw Proberen"
                },
                "message": {
                    "successSubscripionResumed": "Uw abonnement is hervat, uw account wordt binnenkort bijgewerkt!",
                    "successSubscripionCancelled": "Uw abonnement is ingesteld om aan het einde van de periode te worden geannuleerd!",
                    "successSubscripionAutoRenewalEnabled": "Uw abonnement is ingesteld om automatisch te worden verlengd aan het einde van de periode!",
                    "activeSubscription": "U heeft al een actief abonnement",
                    "incompleteSubscription": "U heeft een abonnement dat onvolledig is."
                }
            },
            "modal": {
                "button": {
                    "cancel": "Annuleren",
                    "enableAutoRenewal": "Automatische verlenging inschakelen",
                    "cancelSubscription": "Abonnement annuleren"
                }
            }
        },
        "modal": {
            "enableAutoRenewal": {
                "header": "Automatische Verlenging Inschakelen",
                "body": "Weet u zeker dat u automatische verlenging voor uw abonnement wilt inschakelen?"
            },
            "cancel": {
                "header": "Abonnement Annuleren",
                "body": "Weet u zeker dat u uw abonnement wilt annuleren?"
            },
            "resume": {
                "header": "Abonnement Hervatten",
                "body": {
                    "description": "Weet u zeker dat u het abonnement wilt hervatten?",
                    "note": "<strong>Opmerking:</strong> De nieuwste abonnementsprijzen zijn van toepassing!"
                },
                "button": {
                    "cancel": "Annuleren",
                    "resume": "Hervatten"
                },
                "message": {
                    "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
                }
            },
            "retryPayment": {
                "header": "Abonnementsbetaling Opnieuw Proberen",
                "body": {
                    "description": "Weet u zeker dat u de betaling voor het abonnement opnieuw wilt proberen?",
                    "note": "<strong>Opmerking:</strong> De nieuwste abonnementsprijzen zijn van toepassing!"
                },
                "button": {
                    "cancel": "Annuleren",
                    "retry": "Opnieuw Proberen"
                },
                "message": {
                    "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
                }
            }
        },
        "message": {
            "errorPaymentFailed": "Abonnementsbetaling mislukt, probeer het later opnieuw!",
            "errorCardExpired": "Uw kaart is verlopen. Voeg een geldige standaard <1>betaalmethode</1> toe en probeer de betaling opnieuw.",
            "errorNoPaymentMethod": "U heeft geen <1>betaalmethode</1> aan uw profiel toegevoegd. Voeg een geldige standaard <3>betaalmethode</3> toe en probeer de betaling opnieuw.",
            "moduleNoAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        }
    },
    "subscriptionTiers": {
        "form": {
            "title": "Kies Uw Plan",
            "button": {
                "startNow": "Begin Nu"
            }
        },
        "message": {
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        }
    },
    "upgrade": {
        "form": {
            "title": "Upgrade Uw Abonnement",
            "button": {
                "upgrade": "Upgraden",
                "currentPlan": "Huidig Plan"
            }
        },
        "modal": {
            "upgradeSubscription": {
                "header": "Abonnement Upgraden",
                "body": {
                    "description": "Weet u zeker dat u uw abonnementsplan wilt upgraden naar <strong>{{newTierName}}</strong>.",
                    "note": "<strong>Opmerking: De factureringsperiode voor het abonnement blijft ongewijzigd en u wordt alleen gefactureerd voor het bedrag exclusief wat u al heeft betaald voor het bestaande plan.</strong>"
                },
                "button": {
                    "cancel": "Annuleren",
                    "confirm": "Bevestigen"
                }
            }
        },
        "message": {
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "moduleNoAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        }
    },
    "confirmModal": {
        "header": "Bevestig Uw Informatie",
        "body": {
            "form": {
                "label": {
                    "firstName": "Voornaam",
                    "lastName": "Achternaam",
                    "country": "Woonland",
                    "refundPolicyAgreement": "Door verder te gaan, erken en accepteer ik dat deze betaling definitief en niet-restitueerbaar is. <1>Restitutiebeleid</1>",
                },
                "help_text": {
                    "firstName": "Bevestig alstublieft dat dit uw wettelijke voornaam is.",
                    "lastName": "Bevestig alstublieft dat dit uw wettelijke achternaam is.",
                    "country": "Geef alstublieft uw huidige woonland op."
                },
                "message": {
                    "error": "Fout opgetreden bij het aanmaken van abonnement!",
                    "note": "Opmerking: De nauwkeurigheid van de informatie die u hier verstrekt is essentieel voor de volgende stappen. Zorg ervoor dat alle informatie nauwkeurig en waarheidsgetrouw wordt verstrekt."
                }
            }
        },
        "button": {
            "cancel": "Annuleren",
            "confirm": "Bevestigen"
        }
    },
    "upgradeFailure": {
        "view": {
            "title": "Abonnement Upgrade Mislukt :(",
            "description": "Er was een probleem bij het upgraden van uw abonnement. Probeer het later opnieuw!",
            "button": {
                "returnToDashboard": "Terug naar Dashboard"
            }
        }
    },
    "upgradeSuccess": {
        "view": {
            "title": "Abonnement Geüpgraded :)",
            "description": "U heeft uw abonnement succesvol geüpgraded, uw account wordt binnenkort bijgewerkt!",
            "button": {
                "returnToDashboard": "Terug naar Dashboard"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transactie Geannuleerd :(",
            "description": "De transactie is geannuleerd... Probeer het later opnieuw!",
            "button": {
                "returnToDashboard": "Terug naar Dashboard"
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transactie Succesvol :)",
            "description": "U heeft uw abonnement succesvol bevestigd, uw account wordt binnenkort geüpgraded!",
            "button": {
                "returnToDashboard": "Terug naar Dashboard"
            }
        }
    }
};

export default subscriptionNL;